/*
 * Copyright (c) 2022. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

interface Props {
  symbol: string;
  label?: string;
  fontSize?: number;
}

export const Emoji = ({ symbol, label, fontSize = 12 }: Readonly<Props>) => (
  <span className="emoji" aria-hidden={!label} style={{ fontSize }}>
    {symbol}
  </span>
);
